import * as React from 'react';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import { Icon } from '@iconify/react';

export default function Placeholder() {
  return (
        <Box
            sx={{
                height: '100%',
                display: 'grid',
            }}
            >
            <Card 
                sx={{
                display: 'flex',
                alignItems: 'center',
                }}
                >
                <Box 
                    alignItems="center"
                    justifyContent="center"
                    mx="auto"
                    py={8}
                    >
                    <Icon height={100} color="#EEEDED" icon="fluent:add-48-regular"/>
                </Box>
            </Card>
        </Box>
  );
}